import { render } from "./DocumentUpload.vue?vue&type=template&id=7179e006&scoped=true&ts=true"
import script from "./DocumentUpload.vue?vue&type=script&lang=ts"
export * from "./DocumentUpload.vue?vue&type=script&lang=ts"

import "./DocumentUpload.vue?vue&type=style&index=0&id=7179e006&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7179e006"]])

export default __exports__